module.exports = __webpack_public_path__ + "static/media/Pulmonology-Epworth Sleepiness Scale-1@3x.d71f9ee9.png";